// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n@media (max-width: 500px) {\n.flex-row .toggle-settings-box .m-portlet__body {\n    flex-direction: column;\n    align-items: center;\n}\n}\n", ""]);
// Exports
module.exports = exports;
